import { render, staticRenderFns } from "./InfoboxChecklist.vue?vue&type=template&id=59efd628&scoped=true"
import script from "./InfoboxChecklist.vue?vue&type=script&lang=js"
export * from "./InfoboxChecklist.vue?vue&type=script&lang=js"
import style0 from "./InfoboxChecklist.vue?vue&type=style&index=0&id=59efd628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59efd628",
  null
  
)

export default component.exports